export default __webpack_public_path__ + "static/media/S_Aplus_False.94062df8.jpg";